var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-3h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M22 .5c.413 0 .787.17 1.059.441.238.238.397.554.433.906L23.5 2l-.01 14a1.501 1.501 0 01-1.338 1.492L22 17.5H2c-.413 0-.787-.17-1.059-.441a1.498 1.498 0 01-.433-.906L.5 16V2c0-.412.17-.787.441-1.059.238-.238.554-.397.906-.433L2 .5h20zm-2.934 1.859a7.978 7.978 0 00-3.268 4.507A7.871 7.871 0 0015.5 9c0 .737.106 1.452.299 2.135a8.007 8.007 0 003.267 4.506h0l2.595-2.595L19.74 10.5h-1.523l-.075-.29C18.05 9.82 18 9.416 18 9c0-.52.079-1.021.216-1.5h1.523l1.922-2.546zM8 10.4c-1.21 0-3.116.382-4.518 1.107-.588.303-1.088.668-1.432 1.08-.353.423-.55.897-.55 1.413h0v1.5h13V14l-.01-.191c-.042-.443-.23-.852-.54-1.222-.344-.412-.844-.777-1.432-1.08C11.116 10.782 9.21 10.4 8 10.4zm0-7.9c-.968 0-1.843.391-2.476 1.024A3.489 3.489 0 004.5 6c0 .968.391 1.843 1.024 2.476A3.489 3.489 0 008 9.5c.968 0 1.843-.391 2.476-1.024A3.489 3.489 0 0011.5 6c0-.968-.391-1.843-1.024-2.476A3.489 3.489 0 008 2.5z"
}));

var SvgMemberDetails = function SvgMemberDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMemberDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/member-details.2d2b0ecf.svg";
export { ForwardRef as ReactComponent };